import { BottomSheet, EmptyState } from "@helmr/ui";
import { strings } from "../strings";
import { mobile } from "./strings";
import { useSheetBack } from "./useSheetBack";

/** No notifications API yet: the same honest empty state as the desktop bell. */
export function BellSheet({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  useSheetBack(open, () => onOpenChange(false));
  return (
    <BottomSheet open={open} onOpenChange={onOpenChange} title={mobile.bell.title}>
      <EmptyState compact icon="bell" title={strings.shell.notificationsEmptyTitle} description={strings.shell.notificationsEmptyBody} />
    </BottomSheet>
  );
}
